import { render } from "./Delete.vue?vue&type=template&id=5b5956a7"
import script from "./Delete.vue?vue&type=script&lang=js"
export * from "./Delete.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Delete.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b5956a7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b5956a7', __exports__)) {
    api.reload('5b5956a7', __exports__)
  }
  
  module.hot.accept("./Delete.vue?vue&type=template&id=5b5956a7", () => {
    api.rerender('5b5956a7', render)
  })

}


export default __exports__